import { gql } from "@apollo/client";

export const SURVEYS_QUERY = gql`
    query Surveys($status: String) {
        surveys(status: $status) {
            id
            title
            description
            isAnonymous
            vpReward
            status
            targetType
            endDate
            imageUrl
            videoUrl
            responseCount
            hasResponses
            viewCount
            completionRate
            createdAt
            updatedAt
            myResponse {
                id
            }
        }
    }
`;

export const SURVEY_DETAIL_QUERY = gql`
    query SurveyDetail($id: UUID!) {
        survey(id: $id) {
            id
            title
            description
            isAnonymous
            vpReward
            status
            targetType
            targetUsers {
                userId
                name
                nickname
            }
            endDate
            imageUrl
            videoUrl
            createdAt
            updatedAt
            responseCount
            hasResponses
            viewCount
            completionRate
            myResponse {
                id
                completedAt
                vpAwarded
            }
            questions {
                id
                text
                questionType
                isRequired
                order
                imageUrl
                videoUrl
                conditionalOnId
                conditionalValue
                options {
                    id
                    text
                    order
                }
                images {
                    id
                    imageUrl
                    order
                }
            }
        }
    }
`;

export const MY_PENDING_SURVEYS_QUERY = gql`
    query MyPendingSurveys {
        myPendingSurveys {
            id
            title
            vpReward
        }
    }
`;

export const SURVEY_ANALYTICS_QUERY = gql`
    query SurveyAnalytics($id: UUID!) {
        surveyAnalytics(id: $id) {
            totalTargeted
            totalResponses
            totalViews
            completionRate
            questions {
                questionId
                text
                questionType
                totalAnswers
                optionBreakdown {
                    optionId
                    text
                    count
                    percentage
                }
                textResponses
                numberAverage
                numberMin
                numberMax
            }
        }
    }
`;

export const SURVEY_RESPONSES_QUERY = gql`
    query SurveyResponses($id: UUID!) {
        surveyResponses(id: $id) {
            id
            username
            completedAt
            vpAwarded
            answers {
                id
                question {
                    id
                    text
                    questionType
                    order
                }
                textAnswer
                numberAnswer
                selectedOptions {
                    id
                    text
                }
            }
        }
    }
`;
